/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../types/graphqlapi";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const isEmailExistLf = /* GraphQL */ `query IsEmailExistLf($email: String) {
  isEmailExistLf(email: $email) {
    statusCode
    headers
    body
    isBase64Encoded
    __typename
  }
}
` as GeneratedQuery<
  APITypes.IsEmailExistLfQueryVariables,
  APITypes.IsEmailExistLfQuery
>;
export const listAdminGroupUserLf = /* GraphQL */ `query ListAdminGroupUserLf($id: String) {
  listAdminGroupUserLf(id: $id) {
    statusCode
    headers
    body
    isBase64Encoded
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAdminGroupUserLfQueryVariables,
  APITypes.ListAdminGroupUserLfQuery
>;
export const getAdminUserLf = /* GraphQL */ `query GetAdminUserLf($user_id: String!) {
  getAdminUserLf(user_id: $user_id) {
    statusCode
    headers
    body
    isBase64Encoded
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAdminUserLfQueryVariables,
  APITypes.GetAdminUserLfQuery
>;
export const getGroup = /* GraphQL */ `query GetGroup($id: ID!) {
  getGroup(id: $id) {
    id
    name
    memo
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetGroupQueryVariables, APITypes.GetGroupQuery>;
export const listGroups = /* GraphQL */ `query ListGroups(
  $filter: ModelGroupFilterInput
  $limit: Int
  $nextToken: String
) {
  listGroups(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      memo
      groups
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListGroupsQueryVariables,
  APITypes.ListGroupsQuery
>;
export const getUser = /* GraphQL */ `query GetUser($id: ID!) {
  getUser(id: $id) {
    id
    group_id
    name
    email
    role
    is_personal_data_handler
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetUserQueryVariables, APITypes.GetUserQuery>;
export const listUsers = /* GraphQL */ `query ListUsers(
  $filter: ModelUserFilterInput
  $limit: Int
  $nextToken: String
) {
  listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      group_id
      name
      email
      role
      is_personal_data_handler
      groups
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<APITypes.ListUsersQueryVariables, APITypes.ListUsersQuery>;
export const listUserByGroup = /* GraphQL */ `query ListUserByGroup(
  $group_id: ID
  $email: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelUserFilterInput
  $limit: Int
  $nextToken: String
) {
  listUserByGroup(
    group_id: $group_id
    email: $email
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      group_id
      name
      email
      role
      is_personal_data_handler
      groups
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUserByGroupQueryVariables,
  APITypes.ListUserByGroupQuery
>;
export const getSubject = /* GraphQL */ `query GetSubject($id: ID!) {
  getSubject(id: $id) {
    id
    group_id
    subject_seq
    subject_number
    subject_name
    subject_description
    subject_purpose
    interview_type
    start_date
    end_date
    input_expiration_date
    expiration_date
    main_user_id_group
    main_user_id_asmarq
    memo
    canceled
    finished
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSubjectQueryVariables,
  APITypes.GetSubjectQuery
>;
export const listSubjects = /* GraphQL */ `query ListSubjects(
  $filter: ModelSubjectFilterInput
  $limit: Int
  $nextToken: String
) {
  listSubjects(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      group_id
      subject_seq
      subject_number
      subject_name
      subject_description
      subject_purpose
      interview_type
      start_date
      end_date
      input_expiration_date
      expiration_date
      main_user_id_group
      main_user_id_asmarq
      memo
      canceled
      finished
      groups
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSubjectsQueryVariables,
  APITypes.ListSubjectsQuery
>;
export const listSubjectSortBySeq = /* GraphQL */ `query ListSubjectSortBySeq(
  $group_id: ID
  $subject_seq: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelSubjectFilterInput
  $limit: Int
  $nextToken: String
) {
  listSubjectSortBySeq(
    group_id: $group_id
    subject_seq: $subject_seq
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      group_id
      subject_seq
      subject_number
      subject_name
      subject_description
      subject_purpose
      interview_type
      start_date
      end_date
      input_expiration_date
      expiration_date
      main_user_id_group
      main_user_id_asmarq
      memo
      canceled
      finished
      groups
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSubjectSortBySeqQueryVariables,
  APITypes.ListSubjectSortBySeqQuery
>;
export const listSubjectSortByExpirationDate = /* GraphQL */ `query ListSubjectSortByExpirationDate(
  $group_id: ID
  $expiration_date: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelSubjectFilterInput
  $limit: Int
  $nextToken: String
) {
  listSubjectSortByExpirationDate(
    group_id: $group_id
    expiration_date: $expiration_date
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      group_id
      subject_seq
      subject_number
      subject_name
      subject_description
      subject_purpose
      interview_type
      start_date
      end_date
      input_expiration_date
      expiration_date
      main_user_id_group
      main_user_id_asmarq
      memo
      canceled
      finished
      groups
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSubjectSortByExpirationDateQueryVariables,
  APITypes.ListSubjectSortByExpirationDateQuery
>;
export const getMarkedSubject = /* GraphQL */ `query GetMarkedSubject($id: ID!) {
  getMarkedSubject(id: $id) {
    id
    user_id
    subject_id
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetMarkedSubjectQueryVariables,
  APITypes.GetMarkedSubjectQuery
>;
export const listMarkedSubjects = /* GraphQL */ `query ListMarkedSubjects(
  $filter: ModelMarkedSubjectFilterInput
  $limit: Int
  $nextToken: String
) {
  listMarkedSubjects(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      user_id
      subject_id
      groups
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListMarkedSubjectsQueryVariables,
  APITypes.ListMarkedSubjectsQuery
>;
export const listMarkedSubjectByUserId = /* GraphQL */ `query ListMarkedSubjectByUserId(
  $user_id: ID
  $sortDirection: ModelSortDirection
  $filter: ModelMarkedSubjectFilterInput
  $limit: Int
  $nextToken: String
) {
  listMarkedSubjectByUserId(
    user_id: $user_id
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      user_id
      subject_id
      groups
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListMarkedSubjectByUserIdQueryVariables,
  APITypes.ListMarkedSubjectByUserIdQuery
>;
export const listMarkedSubjectBySubjectId = /* GraphQL */ `query ListMarkedSubjectBySubjectId(
  $subject_id: ID
  $sortDirection: ModelSortDirection
  $filter: ModelMarkedSubjectFilterInput
  $limit: Int
  $nextToken: String
) {
  listMarkedSubjectBySubjectId(
    subject_id: $subject_id
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      user_id
      subject_id
      groups
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListMarkedSubjectBySubjectIdQueryVariables,
  APITypes.ListMarkedSubjectBySubjectIdQuery
>;
export const getInterview = /* GraphQL */ `query GetInterview($id: ID!) {
  getInterview(id: $id) {
    id
    subject_id
    interview_seq
    interview_type
    scheduled_start_date
    scheduled_end_date
    scheduled_start_time
    scheduled_end_time
    actual_start_date
    actual_end_date
    actual_start_time
    actual_end_time
    canceled
    memo
    note
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetInterviewQueryVariables,
  APITypes.GetInterviewQuery
>;
export const listInterviews = /* GraphQL */ `query ListInterviews(
  $filter: ModelInterviewFilterInput
  $limit: Int
  $nextToken: String
) {
  listInterviews(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      subject_id
      interview_seq
      interview_type
      scheduled_start_date
      scheduled_end_date
      scheduled_start_time
      scheduled_end_time
      actual_start_date
      actual_end_date
      actual_start_time
      actual_end_time
      canceled
      memo
      note
      groups
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListInterviewsQueryVariables,
  APITypes.ListInterviewsQuery
>;
export const listInterviewSortBySeq = /* GraphQL */ `query ListInterviewSortBySeq(
  $subject_id: ID
  $interview_seq: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelInterviewFilterInput
  $limit: Int
  $nextToken: String
) {
  listInterviewSortBySeq(
    subject_id: $subject_id
    interview_seq: $interview_seq
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      subject_id
      interview_seq
      interview_type
      scheduled_start_date
      scheduled_end_date
      scheduled_start_time
      scheduled_end_time
      actual_start_date
      actual_end_date
      actual_start_time
      actual_end_time
      canceled
      memo
      note
      groups
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListInterviewSortBySeqQueryVariables,
  APITypes.ListInterviewSortBySeqQuery
>;
export const getFileResource = /* GraphQL */ `query GetFileResource($id: ID!) {
  getFileResource(id: $id) {
    id
    subject_id
    sort_index
    file_name
    title
    type
    url
    description
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetFileResourceQueryVariables,
  APITypes.GetFileResourceQuery
>;
export const listFileResources = /* GraphQL */ `query ListFileResources(
  $filter: ModelFileResourceFilterInput
  $limit: Int
  $nextToken: String
) {
  listFileResources(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      subject_id
      sort_index
      file_name
      title
      type
      url
      description
      groups
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListFileResourcesQueryVariables,
  APITypes.ListFileResourcesQuery
>;
export const listFileResourceSortBySortIndex = /* GraphQL */ `query ListFileResourceSortBySortIndex(
  $subject_id: ID
  $sort_index: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelFileResourceFilterInput
  $limit: Int
  $nextToken: String
) {
  listFileResourceSortBySortIndex(
    subject_id: $subject_id
    sort_index: $sort_index
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      subject_id
      sort_index
      file_name
      title
      type
      url
      description
      groups
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListFileResourceSortBySortIndexQueryVariables,
  APITypes.ListFileResourceSortBySortIndexQuery
>;
export const getScenario = /* GraphQL */ `query GetScenario($id: ID!) {
  getScenario(id: $id) {
    id
    subject_id
    sort_index
    scenario_no
    template_no
    text
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetScenarioQueryVariables,
  APITypes.GetScenarioQuery
>;
export const listScenarios = /* GraphQL */ `query ListScenarios(
  $filter: ModelScenarioFilterInput
  $limit: Int
  $nextToken: String
) {
  listScenarios(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      subject_id
      sort_index
      scenario_no
      template_no
      text
      groups
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListScenariosQueryVariables,
  APITypes.ListScenariosQuery
>;
export const listScenarioSortBySortIndex = /* GraphQL */ `query ListScenarioSortBySortIndex(
  $subject_id: ID
  $sort_index: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelScenarioFilterInput
  $limit: Int
  $nextToken: String
) {
  listScenarioSortBySortIndex(
    subject_id: $subject_id
    sort_index: $sort_index
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      subject_id
      sort_index
      scenario_no
      template_no
      text
      groups
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListScenarioSortBySortIndexQueryVariables,
  APITypes.ListScenarioSortBySortIndexQuery
>;
export const getMonitor = /* GraphQL */ `query GetMonitor($id: ID!) {
  getMonitor(id: $id) {
    id
    subject_id
    ans_id
    classification
    member_id
    name
    sex
    age
    address
    marriage
    children
    job
    memo
    sort_index
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetMonitorQueryVariables,
  APITypes.GetMonitorQuery
>;
export const listMonitors = /* GraphQL */ `query ListMonitors(
  $filter: ModelMonitorFilterInput
  $limit: Int
  $nextToken: String
) {
  listMonitors(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      subject_id
      ans_id
      classification
      member_id
      name
      sex
      age
      address
      marriage
      children
      job
      memo
      sort_index
      groups
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListMonitorsQueryVariables,
  APITypes.ListMonitorsQuery
>;
export const listMonitorSortByAnsId = /* GraphQL */ `query ListMonitorSortByAnsId(
  $subject_id: ID
  $ans_id: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelMonitorFilterInput
  $limit: Int
  $nextToken: String
) {
  listMonitorSortByAnsId(
    subject_id: $subject_id
    ans_id: $ans_id
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      subject_id
      ans_id
      classification
      member_id
      name
      sex
      age
      address
      marriage
      children
      job
      memo
      sort_index
      groups
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListMonitorSortByAnsIdQueryVariables,
  APITypes.ListMonitorSortByAnsIdQuery
>;
export const getMonitorAssign = /* GraphQL */ `query GetMonitorAssign($id: ID!) {
  getMonitorAssign(id: $id) {
    id
    subject_id
    monitor_id
    interview_id
    pin
    last_entry_date
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetMonitorAssignQueryVariables,
  APITypes.GetMonitorAssignQuery
>;
export const listMonitorAssigns = /* GraphQL */ `query ListMonitorAssigns(
  $filter: ModelMonitorAssignFilterInput
  $limit: Int
  $nextToken: String
) {
  listMonitorAssigns(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      subject_id
      monitor_id
      interview_id
      pin
      last_entry_date
      groups
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListMonitorAssignsQueryVariables,
  APITypes.ListMonitorAssignsQuery
>;
export const listMonitorAssignBySubjectId = /* GraphQL */ `query ListMonitorAssignBySubjectId(
  $subject_id: ID
  $sortDirection: ModelSortDirection
  $filter: ModelMonitorAssignFilterInput
  $limit: Int
  $nextToken: String
) {
  listMonitorAssignBySubjectId(
    subject_id: $subject_id
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      subject_id
      monitor_id
      interview_id
      pin
      last_entry_date
      groups
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListMonitorAssignBySubjectIdQueryVariables,
  APITypes.ListMonitorAssignBySubjectIdQuery
>;
export const listMonitorAssignByInterviewId = /* GraphQL */ `query ListMonitorAssignByInterviewId(
  $interview_id: ID
  $sortDirection: ModelSortDirection
  $filter: ModelMonitorAssignFilterInput
  $limit: Int
  $nextToken: String
) {
  listMonitorAssignByInterviewId(
    interview_id: $interview_id
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      subject_id
      monitor_id
      interview_id
      pin
      last_entry_date
      groups
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListMonitorAssignByInterviewIdQueryVariables,
  APITypes.ListMonitorAssignByInterviewIdQuery
>;
export const listMonitorAssignByMonitorId = /* GraphQL */ `query ListMonitorAssignByMonitorId(
  $monitor_id: ID
  $sortDirection: ModelSortDirection
  $filter: ModelMonitorAssignFilterInput
  $limit: Int
  $nextToken: String
) {
  listMonitorAssignByMonitorId(
    monitor_id: $monitor_id
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      subject_id
      monitor_id
      interview_id
      pin
      last_entry_date
      groups
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListMonitorAssignByMonitorIdQueryVariables,
  APITypes.ListMonitorAssignByMonitorIdQuery
>;
export const getMonitorAttribute = /* GraphQL */ `query GetMonitorAttribute($id: ID!) {
  getMonitorAttribute(id: $id) {
    id
    subject_id
    monitor_id
    seq_no
    name
    value
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetMonitorAttributeQueryVariables,
  APITypes.GetMonitorAttributeQuery
>;
export const listMonitorAttributes = /* GraphQL */ `query ListMonitorAttributes(
  $filter: ModelMonitorAttributeFilterInput
  $limit: Int
  $nextToken: String
) {
  listMonitorAttributes(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      subject_id
      monitor_id
      seq_no
      name
      value
      groups
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListMonitorAttributesQueryVariables,
  APITypes.ListMonitorAttributesQuery
>;
export const listSortMonitorAttributeBySeqNo = /* GraphQL */ `query ListSortMonitorAttributeBySeqNo(
  $monitor_id: ID
  $seq_no: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelMonitorAttributeFilterInput
  $limit: Int
  $nextToken: String
) {
  listSortMonitorAttributeBySeqNo(
    monitor_id: $monitor_id
    seq_no: $seq_no
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      subject_id
      monitor_id
      seq_no
      name
      value
      groups
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSortMonitorAttributeBySeqNoQueryVariables,
  APITypes.ListSortMonitorAttributeBySeqNoQuery
>;
export const listMonitorAttributeBySubjectId = /* GraphQL */ `query ListMonitorAttributeBySubjectId(
  $subject_id: ID
  $sortDirection: ModelSortDirection
  $filter: ModelMonitorAttributeFilterInput
  $limit: Int
  $nextToken: String
) {
  listMonitorAttributeBySubjectId(
    subject_id: $subject_id
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      subject_id
      monitor_id
      seq_no
      name
      value
      groups
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListMonitorAttributeBySubjectIdQueryVariables,
  APITypes.ListMonitorAttributeBySubjectIdQuery
>;
export const getMonitorCheckResult = /* GraphQL */ `query GetMonitorCheckResult($id: ID!) {
  getMonitorCheckResult(id: $id) {
    id
    monitor_id
    subject_id
    interview_id
    initial_name
    initial_sex
    initial_age
    initial_address
    initial_marriage
    initial_children
    initial_job
    monitor_check_result_type
    submitted_text
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetMonitorCheckResultQueryVariables,
  APITypes.GetMonitorCheckResultQuery
>;
export const listMonitorCheckResults = /* GraphQL */ `query ListMonitorCheckResults(
  $filter: ModelMonitorCheckResultFilterInput
  $limit: Int
  $nextToken: String
) {
  listMonitorCheckResults(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      monitor_id
      subject_id
      interview_id
      initial_name
      initial_sex
      initial_age
      initial_address
      initial_marriage
      initial_children
      initial_job
      monitor_check_result_type
      submitted_text
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListMonitorCheckResultsQueryVariables,
  APITypes.ListMonitorCheckResultsQuery
>;
export const listMonitorCheckResultByMonitorId = /* GraphQL */ `query ListMonitorCheckResultByMonitorId(
  $monitor_id: ID
  $interview_id: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelMonitorCheckResultFilterInput
  $limit: Int
  $nextToken: String
) {
  listMonitorCheckResultByMonitorId(
    monitor_id: $monitor_id
    interview_id: $interview_id
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      monitor_id
      subject_id
      interview_id
      initial_name
      initial_sex
      initial_age
      initial_address
      initial_marriage
      initial_children
      initial_job
      monitor_check_result_type
      submitted_text
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListMonitorCheckResultByMonitorIdQueryVariables,
  APITypes.ListMonitorCheckResultByMonitorIdQuery
>;
export const listMonitorCheckResultByInterviewId = /* GraphQL */ `query ListMonitorCheckResultByInterviewId(
  $interview_id: ID
  $sortDirection: ModelSortDirection
  $filter: ModelMonitorCheckResultFilterInput
  $limit: Int
  $nextToken: String
) {
  listMonitorCheckResultByInterviewId(
    interview_id: $interview_id
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      monitor_id
      subject_id
      interview_id
      initial_name
      initial_sex
      initial_age
      initial_address
      initial_marriage
      initial_children
      initial_job
      monitor_check_result_type
      submitted_text
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListMonitorCheckResultByInterviewIdQueryVariables,
  APITypes.ListMonitorCheckResultByInterviewIdQuery
>;
export const listMonitorCheckResultBySubjectId = /* GraphQL */ `query ListMonitorCheckResultBySubjectId(
  $subject_id: ID
  $sortDirection: ModelSortDirection
  $filter: ModelMonitorCheckResultFilterInput
  $limit: Int
  $nextToken: String
) {
  listMonitorCheckResultBySubjectId(
    subject_id: $subject_id
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      monitor_id
      subject_id
      interview_id
      initial_name
      initial_sex
      initial_age
      initial_address
      initial_marriage
      initial_children
      initial_job
      monitor_check_result_type
      submitted_text
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListMonitorCheckResultBySubjectIdQueryVariables,
  APITypes.ListMonitorCheckResultBySubjectIdQuery
>;
export const getChatData = /* GraphQL */ `query GetChatData($id: ID!) {
  getChatData(id: $id) {
    id
    subject_id
    interview_id
    type
    file_type
    text
    file_url
    mentioned_monitor_id_list
    moderator_id
    monitor_id
    sort_index
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetChatDataQueryVariables,
  APITypes.GetChatDataQuery
>;
export const listChatDatas = /* GraphQL */ `query ListChatDatas(
  $filter: ModelChatDataFilterInput
  $limit: Int
  $nextToken: String
) {
  listChatDatas(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      subject_id
      interview_id
      type
      file_type
      text
      file_url
      mentioned_monitor_id_list
      moderator_id
      monitor_id
      sort_index
      groups
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListChatDatasQueryVariables,
  APITypes.ListChatDatasQuery
>;
export const listChatDataSortBySortIndex = /* GraphQL */ `query ListChatDataSortBySortIndex(
  $interview_id: ID
  $sort_index: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelChatDataFilterInput
  $limit: Int
  $nextToken: String
) {
  listChatDataSortBySortIndex(
    interview_id: $interview_id
    sort_index: $sort_index
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      subject_id
      interview_id
      type
      file_type
      text
      file_url
      mentioned_monitor_id_list
      moderator_id
      monitor_id
      sort_index
      groups
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListChatDataSortBySortIndexQueryVariables,
  APITypes.ListChatDataSortBySortIndexQuery
>;
export const getUsedResource = /* GraphQL */ `query GetUsedResource($id: ID!) {
  getUsedResource(id: $id) {
    id
    subject_id
    interview_id
    type
    key
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUsedResourceQueryVariables,
  APITypes.GetUsedResourceQuery
>;
export const listUsedResources = /* GraphQL */ `query ListUsedResources(
  $filter: ModelUsedResourceFilterInput
  $limit: Int
  $nextToken: String
) {
  listUsedResources(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      subject_id
      interview_id
      type
      key
      groups
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUsedResourcesQueryVariables,
  APITypes.ListUsedResourcesQuery
>;
export const listUsedResourcesBySubjectId = /* GraphQL */ `query ListUsedResourcesBySubjectId(
  $subject_id: ID
  $sortDirection: ModelSortDirection
  $filter: ModelUsedResourceFilterInput
  $limit: Int
  $nextToken: String
) {
  listUsedResourcesBySubjectId(
    subject_id: $subject_id
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      subject_id
      interview_id
      type
      key
      groups
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUsedResourcesBySubjectIdQueryVariables,
  APITypes.ListUsedResourcesBySubjectIdQuery
>;
export const listUsedResourcesByInterviewId = /* GraphQL */ `query ListUsedResourcesByInterviewId(
  $interview_id: ID
  $sortDirection: ModelSortDirection
  $filter: ModelUsedResourceFilterInput
  $limit: Int
  $nextToken: String
) {
  listUsedResourcesByInterviewId(
    interview_id: $interview_id
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      subject_id
      interview_id
      type
      key
      groups
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUsedResourcesByInterviewIdQueryVariables,
  APITypes.ListUsedResourcesByInterviewIdQuery
>;
export const getMonitorResource = /* GraphQL */ `query GetMonitorResource($id: ID!) {
  getMonitorResource(id: $id) {
    id
    subject_id
    monitor_id
    interview_id
    sort_index
    file_name
    type
    url
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetMonitorResourceQueryVariables,
  APITypes.GetMonitorResourceQuery
>;
export const listMonitorResources = /* GraphQL */ `query ListMonitorResources(
  $filter: ModelMonitorResourceFilterInput
  $limit: Int
  $nextToken: String
) {
  listMonitorResources(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      subject_id
      monitor_id
      interview_id
      sort_index
      file_name
      type
      url
      groups
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListMonitorResourcesQueryVariables,
  APITypes.ListMonitorResourcesQuery
>;
export const listMonitorResourceSortBySortIndex = /* GraphQL */ `query ListMonitorResourceSortBySortIndex(
  $interview_id: ID
  $sort_index: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelMonitorResourceFilterInput
  $limit: Int
  $nextToken: String
) {
  listMonitorResourceSortBySortIndex(
    interview_id: $interview_id
    sort_index: $sort_index
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      subject_id
      monitor_id
      interview_id
      sort_index
      file_name
      type
      url
      groups
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListMonitorResourceSortBySortIndexQueryVariables,
  APITypes.ListMonitorResourceSortBySortIndexQuery
>;
export const getInterviewResource = /* GraphQL */ `query GetInterviewResource($id: ID!) {
  getInterviewResource(id: $id) {
    id
    subject_id
    interview_id
    sort_index
    chat_data_id
    type
    title
    description
    file_name
    url
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetInterviewResourceQueryVariables,
  APITypes.GetInterviewResourceQuery
>;
export const listInterviewResources = /* GraphQL */ `query ListInterviewResources(
  $filter: ModelInterviewResourceFilterInput
  $limit: Int
  $nextToken: String
) {
  listInterviewResources(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      subject_id
      interview_id
      sort_index
      chat_data_id
      type
      title
      description
      file_name
      url
      groups
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListInterviewResourcesQueryVariables,
  APITypes.ListInterviewResourcesQuery
>;
export const listInterviewResourceSortBySortIndex = /* GraphQL */ `query ListInterviewResourceSortBySortIndex(
  $interview_id: ID
  $sort_index: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelInterviewResourceFilterInput
  $limit: Int
  $nextToken: String
) {
  listInterviewResourceSortBySortIndex(
    interview_id: $interview_id
    sort_index: $sort_index
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      subject_id
      interview_id
      sort_index
      chat_data_id
      type
      title
      description
      file_name
      url
      groups
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListInterviewResourceSortBySortIndexQueryVariables,
  APITypes.ListInterviewResourceSortBySortIndexQuery
>;
export const listInterviewResourceBySubjectId = /* GraphQL */ `query ListInterviewResourceBySubjectId(
  $subject_id: ID
  $sortDirection: ModelSortDirection
  $filter: ModelInterviewResourceFilterInput
  $limit: Int
  $nextToken: String
) {
  listInterviewResourceBySubjectId(
    subject_id: $subject_id
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      subject_id
      interview_id
      sort_index
      chat_data_id
      type
      title
      description
      file_name
      url
      groups
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListInterviewResourceBySubjectIdQueryVariables,
  APITypes.ListInterviewResourceBySubjectIdQuery
>;
export const getChatToken = /* GraphQL */ `query GetChatToken($id: ID!) {
  getChatToken(id: $id) {
    id
    subject_id
    interview_id
    moderator_id
    monitor_id
    last_event_dates_id
    last_event_dates_updatedAt
    typing_chat_data_id
    read_index_id
    refreshed_at
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetChatTokenQueryVariables,
  APITypes.GetChatTokenQuery
>;
export const listChatTokens = /* GraphQL */ `query ListChatTokens(
  $filter: ModelChatTokenFilterInput
  $limit: Int
  $nextToken: String
) {
  listChatTokens(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      subject_id
      interview_id
      moderator_id
      monitor_id
      last_event_dates_id
      last_event_dates_updatedAt
      typing_chat_data_id
      read_index_id
      refreshed_at
      groups
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListChatTokensQueryVariables,
  APITypes.ListChatTokensQuery
>;
export const listChatTokenByInterviewId = /* GraphQL */ `query ListChatTokenByInterviewId(
  $interview_id: ID
  $sortDirection: ModelSortDirection
  $filter: ModelChatTokenFilterInput
  $limit: Int
  $nextToken: String
) {
  listChatTokenByInterviewId(
    interview_id: $interview_id
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      subject_id
      interview_id
      moderator_id
      monitor_id
      last_event_dates_id
      last_event_dates_updatedAt
      typing_chat_data_id
      read_index_id
      refreshed_at
      groups
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListChatTokenByInterviewIdQueryVariables,
  APITypes.ListChatTokenByInterviewIdQuery
>;
export const listChatTokenByModeratorIdSortByCreatedAt = /* GraphQL */ `query ListChatTokenByModeratorIdSortByCreatedAt(
  $moderator_id: ID
  $interview_idCreatedAt: ModelChatTokenByModeratorIdSortByCreatedAtCompositeKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelChatTokenFilterInput
  $limit: Int
  $nextToken: String
) {
  listChatTokenByModeratorIdSortByCreatedAt(
    moderator_id: $moderator_id
    interview_idCreatedAt: $interview_idCreatedAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      subject_id
      interview_id
      moderator_id
      monitor_id
      last_event_dates_id
      last_event_dates_updatedAt
      typing_chat_data_id
      read_index_id
      refreshed_at
      groups
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListChatTokenByModeratorIdSortByCreatedAtQueryVariables,
  APITypes.ListChatTokenByModeratorIdSortByCreatedAtQuery
>;
export const getLastEventDates = /* GraphQL */ `query GetLastEventDates($id: ID!) {
  getLastEventDates(id: $id) {
    id
    chat_created
    monitor_typing
    moderator_read
    monitor_read
    interviewer_announce
    chat_token_id
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLastEventDatesQueryVariables,
  APITypes.GetLastEventDatesQuery
>;
export const listLastEventDatess = /* GraphQL */ `query ListLastEventDatess(
  $filter: ModelLastEventDatesFilterInput
  $limit: Int
  $nextToken: String
) {
  listLastEventDatess(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      chat_created
      monitor_typing
      moderator_read
      monitor_read
      interviewer_announce
      chat_token_id
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLastEventDatessQueryVariables,
  APITypes.ListLastEventDatessQuery
>;
export const listLastEventDatesByChatTokenId = /* GraphQL */ `query ListLastEventDatesByChatTokenId(
  $chat_token_id: ID
  $sortDirection: ModelSortDirection
  $filter: ModelLastEventDatesFilterInput
  $limit: Int
  $nextToken: String
) {
  listLastEventDatesByChatTokenId(
    chat_token_id: $chat_token_id
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      chat_created
      monitor_typing
      moderator_read
      monitor_read
      interviewer_announce
      chat_token_id
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLastEventDatesByChatTokenIdQueryVariables,
  APITypes.ListLastEventDatesByChatTokenIdQuery
>;
export const getLastChatSortIndex = /* GraphQL */ `query GetLastChatSortIndex($id: ID!) {
  getLastChatSortIndex(id: $id) {
    id
    interview_id
    chat_sort_index
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLastChatSortIndexQueryVariables,
  APITypes.GetLastChatSortIndexQuery
>;
export const listLastChatSortIndexs = /* GraphQL */ `query ListLastChatSortIndexs(
  $filter: ModelLastChatSortIndexFilterInput
  $limit: Int
  $nextToken: String
) {
  listLastChatSortIndexs(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      interview_id
      chat_sort_index
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLastChatSortIndexsQueryVariables,
  APITypes.ListLastChatSortIndexsQuery
>;
export const listLastChatSortIndexByInterviewId = /* GraphQL */ `query ListLastChatSortIndexByInterviewId(
  $interview_id: ID
  $sortDirection: ModelSortDirection
  $filter: ModelLastChatSortIndexFilterInput
  $limit: Int
  $nextToken: String
) {
  listLastChatSortIndexByInterviewId(
    interview_id: $interview_id
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      interview_id
      chat_sort_index
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLastChatSortIndexByInterviewIdQueryVariables,
  APITypes.ListLastChatSortIndexByInterviewIdQuery
>;
export const getTypingChatData = /* GraphQL */ `query GetTypingChatData($id: ID!) {
  getTypingChatData(id: $id) {
    id
    subject_id
    interview_id
    text
    moderator_id
    monitor_id
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetTypingChatDataQueryVariables,
  APITypes.GetTypingChatDataQuery
>;
export const listTypingChatDatas = /* GraphQL */ `query ListTypingChatDatas(
  $filter: ModelTypingChatDataFilterInput
  $limit: Int
  $nextToken: String
) {
  listTypingChatDatas(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      subject_id
      interview_id
      text
      moderator_id
      monitor_id
      groups
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTypingChatDatasQueryVariables,
  APITypes.ListTypingChatDatasQuery
>;
export const listTypingChatDataSortByInterviewId = /* GraphQL */ `query ListTypingChatDataSortByInterviewId(
  $interview_id: ID
  $sortDirection: ModelSortDirection
  $filter: ModelTypingChatDataFilterInput
  $limit: Int
  $nextToken: String
) {
  listTypingChatDataSortByInterviewId(
    interview_id: $interview_id
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      subject_id
      interview_id
      text
      moderator_id
      monitor_id
      groups
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTypingChatDataSortByInterviewIdQueryVariables,
  APITypes.ListTypingChatDataSortByInterviewIdQuery
>;
export const getReadIndex = /* GraphQL */ `query GetReadIndex($id: ID!) {
  getReadIndex(id: $id) {
    id
    subject_id
    interview_id
    moderator_id
    monitor_id
    read_index
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetReadIndexQueryVariables,
  APITypes.GetReadIndexQuery
>;
export const listReadIndexs = /* GraphQL */ `query ListReadIndexs(
  $filter: ModelReadIndexFilterInput
  $limit: Int
  $nextToken: String
) {
  listReadIndexs(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      subject_id
      interview_id
      moderator_id
      monitor_id
      read_index
      groups
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListReadIndexsQueryVariables,
  APITypes.ListReadIndexsQuery
>;
export const listReadIndexSortByInterviewId = /* GraphQL */ `query ListReadIndexSortByInterviewId(
  $interview_id: ID
  $sortDirection: ModelSortDirection
  $filter: ModelReadIndexFilterInput
  $limit: Int
  $nextToken: String
) {
  listReadIndexSortByInterviewId(
    interview_id: $interview_id
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      subject_id
      interview_id
      moderator_id
      monitor_id
      read_index
      groups
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListReadIndexSortByInterviewIdQueryVariables,
  APITypes.ListReadIndexSortByInterviewIdQuery
>;
export const getInterviewerAnnounce = /* GraphQL */ `query GetInterviewerAnnounce($id: ID!) {
  getInterviewerAnnounce(id: $id) {
    id
    subject_id
    interview_id
    text
    sort_index
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetInterviewerAnnounceQueryVariables,
  APITypes.GetInterviewerAnnounceQuery
>;
export const listInterviewerAnnounces = /* GraphQL */ `query ListInterviewerAnnounces(
  $filter: ModelInterviewerAnnounceFilterInput
  $limit: Int
  $nextToken: String
) {
  listInterviewerAnnounces(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      subject_id
      interview_id
      text
      sort_index
      groups
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListInterviewerAnnouncesQueryVariables,
  APITypes.ListInterviewerAnnouncesQuery
>;
export const listInterviewerAnnounceByInterviewIdSortBySortIndex = /* GraphQL */ `query ListInterviewerAnnounceByInterviewIdSortBySortIndex(
  $interview_id: ID
  $sort_index: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelInterviewerAnnounceFilterInput
  $limit: Int
  $nextToken: String
) {
  listInterviewerAnnounceByInterviewIdSortBySortIndex(
    interview_id: $interview_id
    sort_index: $sort_index
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      subject_id
      interview_id
      text
      sort_index
      groups
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListInterviewerAnnounceByInterviewIdSortBySortIndexQueryVariables,
  APITypes.ListInterviewerAnnounceByInterviewIdSortBySortIndexQuery
>;
export const getNotificationEvent = /* GraphQL */ `query GetNotificationEvent($id: ID!) {
  getNotificationEvent(id: $id) {
    id
    subject_id
    interview_id
    sort_index
    groups
    notification_event_type
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetNotificationEventQueryVariables,
  APITypes.GetNotificationEventQuery
>;
export const listNotificationEvents = /* GraphQL */ `query ListNotificationEvents(
  $filter: ModelNotificationEventFilterInput
  $limit: Int
  $nextToken: String
) {
  listNotificationEvents(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      subject_id
      interview_id
      sort_index
      groups
      notification_event_type
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListNotificationEventsQueryVariables,
  APITypes.ListNotificationEventsQuery
>;
export const listNotificationEventByInterviewIdSortBySortIndex = /* GraphQL */ `query ListNotificationEventByInterviewIdSortBySortIndex(
  $interview_id: ID
  $sort_index: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelNotificationEventFilterInput
  $limit: Int
  $nextToken: String
) {
  listNotificationEventByInterviewIdSortBySortIndex(
    interview_id: $interview_id
    sort_index: $sort_index
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      subject_id
      interview_id
      sort_index
      groups
      notification_event_type
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListNotificationEventByInterviewIdSortBySortIndexQueryVariables,
  APITypes.ListNotificationEventByInterviewIdSortBySortIndexQuery
>;
export const getMail = /* GraphQL */ `query GetMail($id: ID!) {
  getMail(id: $id) {
    id
    subject_id
    interview_id
    monitor_id
    heading
    message
    send_status
    notification_event_id
    sort_index
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetMailQueryVariables, APITypes.GetMailQuery>;
export const listMails = /* GraphQL */ `query ListMails(
  $filter: ModelMailFilterInput
  $limit: Int
  $nextToken: String
) {
  listMails(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      subject_id
      interview_id
      monitor_id
      heading
      message
      send_status
      notification_event_id
      sort_index
      groups
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<APITypes.ListMailsQueryVariables, APITypes.ListMailsQuery>;
export const listMailByInterviewIdSortBySortIndex = /* GraphQL */ `query ListMailByInterviewIdSortBySortIndex(
  $interview_id: ID
  $sort_index: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelMailFilterInput
  $limit: Int
  $nextToken: String
) {
  listMailByInterviewIdSortBySortIndex(
    interview_id: $interview_id
    sort_index: $sort_index
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      subject_id
      interview_id
      monitor_id
      heading
      message
      send_status
      notification_event_id
      sort_index
      groups
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListMailByInterviewIdSortBySortIndexQueryVariables,
  APITypes.ListMailByInterviewIdSortBySortIndexQuery
>;
export const listMailByMonitorId = /* GraphQL */ `query ListMailByMonitorId(
  $monitor_id: String
  $sortDirection: ModelSortDirection
  $filter: ModelMailFilterInput
  $limit: Int
  $nextToken: String
) {
  listMailByMonitorId(
    monitor_id: $monitor_id
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      subject_id
      interview_id
      monitor_id
      heading
      message
      send_status
      notification_event_id
      sort_index
      groups
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListMailByMonitorIdQueryVariables,
  APITypes.ListMailByMonitorIdQuery
>;
export const listMailByNotificationEventIdSortBySortIndex = /* GraphQL */ `query ListMailByNotificationEventIdSortBySortIndex(
  $notification_event_id: ID
  $sort_index: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelMailFilterInput
  $limit: Int
  $nextToken: String
) {
  listMailByNotificationEventIdSortBySortIndex(
    notification_event_id: $notification_event_id
    sort_index: $sort_index
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      subject_id
      interview_id
      monitor_id
      heading
      message
      send_status
      notification_event_id
      sort_index
      groups
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListMailByNotificationEventIdSortBySortIndexQueryVariables,
  APITypes.ListMailByNotificationEventIdSortBySortIndexQuery
>;
export const getEmail = /* GraphQL */ `query GetEmail($monitor_id: ID!) {
  getEmail(monitor_id: $monitor_id) {
    id
    monitor_id
    subject_id
    email
    groups
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetEmailQueryVariables, APITypes.GetEmailQuery>;
export const listEmails = /* GraphQL */ `query ListEmails(
  $monitor_id: ID
  $filter: ModelEmailFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listEmails(
    monitor_id: $monitor_id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      monitor_id
      subject_id
      email
      groups
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListEmailsQueryVariables,
  APITypes.ListEmailsQuery
>;
export const listEmailBySubjectId = /* GraphQL */ `query ListEmailBySubjectId(
  $subject_id: ID
  $sortDirection: ModelSortDirection
  $filter: ModelEmailFilterInput
  $limit: Int
  $nextToken: String
) {
  listEmailBySubjectId(
    subject_id: $subject_id
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      monitor_id
      subject_id
      email
      groups
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListEmailBySubjectIdQueryVariables,
  APITypes.ListEmailBySubjectIdQuery
>;
export const sendConfirmationCodeLf = /* GraphQL */ `query SendConfirmationCodeLf($email: String!) {
  sendConfirmationCodeLf(email: $email) {
    statusCode
    headers
    body
    isBase64Encoded
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SendConfirmationCodeLfQueryVariables,
  APITypes.SendConfirmationCodeLfQuery
>;
export const setPasswordLf = /* GraphQL */ `query SetPasswordLf(
  $email: String!
  $confirmation_code: String!
  $password: String!
) {
  setPasswordLf(
    email: $email
    confirmation_code: $confirmation_code
    password: $password
  ) {
    statusCode
    headers
    body
    isBase64Encoded
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SetPasswordLfQueryVariables,
  APITypes.SetPasswordLfQuery
>;
export const getAttendeeRoleLf = /* GraphQL */ `query GetAttendeeRoleLf($attendee_id: String) {
  getAttendeeRoleLf(attendee_id: $attendee_id) {
    statusCode
    headers
    body
    isBase64Encoded
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAttendeeRoleLfQueryVariables,
  APITypes.GetAttendeeRoleLfQuery
>;
export const getMonitorByMonitorAssignIdLf = /* GraphQL */ `query GetMonitorByMonitorAssignIdLf($monitor_assign_id: String) {
  getMonitorByMonitorAssignIdLf(monitor_assign_id: $monitor_assign_id) {
    statusCode
    headers
    body
    isBase64Encoded
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetMonitorByMonitorAssignIdLfQueryVariables,
  APITypes.GetMonitorByMonitorAssignIdLfQuery
>;
export const getMonitorForTestEntryLf = /* GraphQL */ `query GetMonitorForTestEntryLf($chat_token_id: String) {
  getMonitorForTestEntryLf(chat_token_id: $chat_token_id) {
    statusCode
    headers
    body
    isBase64Encoded
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetMonitorForTestEntryLfQueryVariables,
  APITypes.GetMonitorForTestEntryLfQuery
>;
export const getMonitorAssignByMonitorIdLf = /* GraphQL */ `query GetMonitorAssignByMonitorIdLf($chat_token_id: ID!, $monitor_id: String) {
  getMonitorAssignByMonitorIdLf(
    chat_token_id: $chat_token_id
    monitor_id: $monitor_id
  ) {
    statusCode
    headers
    body
    isBase64Encoded
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetMonitorAssignByMonitorIdLfQueryVariables,
  APITypes.GetMonitorAssignByMonitorIdLfQuery
>;
export const getInterviewByMonitorAssignIdLf = /* GraphQL */ `query GetInterviewByMonitorAssignIdLf($monitor_assign_id: String) {
  getInterviewByMonitorAssignIdLf(monitor_assign_id: $monitor_assign_id) {
    statusCode
    headers
    body
    isBase64Encoded
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetInterviewByMonitorAssignIdLfQueryVariables,
  APITypes.GetInterviewByMonitorAssignIdLfQuery
>;
export const getModeratorChatTokenLf = /* GraphQL */ `query GetModeratorChatTokenLf($moderator_id: ID!, $interview_id: ID!) {
  getModeratorChatTokenLf(
    moderator_id: $moderator_id
    interview_id: $interview_id
  ) {
    statusCode
    headers
    body
    isBase64Encoded
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetModeratorChatTokenLfQueryVariables,
  APITypes.GetModeratorChatTokenLfQuery
>;
export const isCorrectPinCodeLf = /* GraphQL */ `query IsCorrectPinCodeLf($monitor_assign_id: ID!, $pin_code: String) {
  isCorrectPinCodeLf(
    monitor_assign_id: $monitor_assign_id
    pin_code: $pin_code
  ) {
    statusCode
    headers
    body
    isBase64Encoded
    __typename
  }
}
` as GeneratedQuery<
  APITypes.IsCorrectPinCodeLfQueryVariables,
  APITypes.IsCorrectPinCodeLfQuery
>;
export const getSubjectLf = /* GraphQL */ `query GetSubjectLf($chat_token_id: ID!) {
  getSubjectLf(chat_token_id: $chat_token_id) {
    statusCode
    headers
    body
    isBase64Encoded
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSubjectLfQueryVariables,
  APITypes.GetSubjectLfQuery
>;
export const getInterviewLf = /* GraphQL */ `query GetInterviewLf($chat_token_id: ID!) {
  getInterviewLf(chat_token_id: $chat_token_id) {
    statusCode
    headers
    body
    isBase64Encoded
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetInterviewLfQueryVariables,
  APITypes.GetInterviewLfQuery
>;
export const listMonitorByInterviewIdLf = /* GraphQL */ `query ListMonitorByInterviewIdLf($chat_token_id: ID!) {
  listMonitorByInterviewIdLf(chat_token_id: $chat_token_id) {
    statusCode
    headers
    body
    isBase64Encoded
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListMonitorByInterviewIdLfQueryVariables,
  APITypes.ListMonitorByInterviewIdLfQuery
>;
export const listMonitorCheckResultByMonitorIdLf = /* GraphQL */ `query ListMonitorCheckResultByMonitorIdLf($chat_token_id: ID!) {
  listMonitorCheckResultByMonitorIdLf(chat_token_id: $chat_token_id) {
    statusCode
    headers
    body
    isBase64Encoded
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListMonitorCheckResultByMonitorIdLfQueryVariables,
  APITypes.ListMonitorCheckResultByMonitorIdLfQuery
>;
export const listMonitorAttributeLf = /* GraphQL */ `query ListMonitorAttributeLf($chat_token_id: ID!, $monitor_id: ID!) {
  listMonitorAttributeLf(
    chat_token_id: $chat_token_id
    monitor_id: $monitor_id
  ) {
    statusCode
    headers
    body
    isBase64Encoded
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListMonitorAttributeLfQueryVariables,
  APITypes.ListMonitorAttributeLfQuery
>;
export const listChatDataByChatTokenIdLf = /* GraphQL */ `query ListChatDataByChatTokenIdLf($chat_token_id: ID!, $sort_index: Int!) {
  listChatDataByChatTokenIdLf(
    chat_token_id: $chat_token_id
    sort_index: $sort_index
  ) {
    statusCode
    headers
    body
    isBase64Encoded
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListChatDataByChatTokenIdLfQueryVariables,
  APITypes.ListChatDataByChatTokenIdLfQuery
>;
export const listScenarioBySubjectIdLf = /* GraphQL */ `query ListScenarioBySubjectIdLf($chat_token_id: ID!) {
  listScenarioBySubjectIdLf(chat_token_id: $chat_token_id) {
    statusCode
    headers
    body
    isBase64Encoded
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListScenarioBySubjectIdLfQueryVariables,
  APITypes.ListScenarioBySubjectIdLfQuery
>;
export const listUsedResourcesByInterviewIdLf = /* GraphQL */ `query ListUsedResourcesByInterviewIdLf($chat_token_id: ID!) {
  listUsedResourcesByInterviewIdLf(chat_token_id: $chat_token_id) {
    statusCode
    headers
    body
    isBase64Encoded
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUsedResourcesByInterviewIdLfQueryVariables,
  APITypes.ListUsedResourcesByInterviewIdLfQuery
>;
export const listFileResourcesBySubjectIdLf = /* GraphQL */ `query ListFileResourcesBySubjectIdLf($chat_token_id: ID!) {
  listFileResourcesBySubjectIdLf(chat_token_id: $chat_token_id) {
    statusCode
    headers
    body
    isBase64Encoded
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListFileResourcesBySubjectIdLfQueryVariables,
  APITypes.ListFileResourcesBySubjectIdLfQuery
>;
export const listMonitorTypingChatDataLf = /* GraphQL */ `query ListMonitorTypingChatDataLf($chat_token_id: ID!) {
  listMonitorTypingChatDataLf(chat_token_id: $chat_token_id) {
    statusCode
    headers
    body
    isBase64Encoded
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListMonitorTypingChatDataLfQueryVariables,
  APITypes.ListMonitorTypingChatDataLfQuery
>;
export const listModeratorReadIndexLf = /* GraphQL */ `query ListModeratorReadIndexLf($chat_token_id: ID!) {
  listModeratorReadIndexLf(chat_token_id: $chat_token_id) {
    statusCode
    headers
    body
    isBase64Encoded
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListModeratorReadIndexLfQueryVariables,
  APITypes.ListModeratorReadIndexLfQuery
>;
export const listMonitorReadIndexLf = /* GraphQL */ `query ListMonitorReadIndexLf($chat_token_id: ID!) {
  listMonitorReadIndexLf(chat_token_id: $chat_token_id) {
    statusCode
    headers
    body
    isBase64Encoded
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListMonitorReadIndexLfQueryVariables,
  APITypes.ListMonitorReadIndexLfQuery
>;
export const listInterviewerAnnounceLf = /* GraphQL */ `query ListInterviewerAnnounceLf($chat_token_id: ID!, $sort_index: Int!) {
  listInterviewerAnnounceLf(
    chat_token_id: $chat_token_id
    sort_index: $sort_index
  ) {
    statusCode
    headers
    body
    isBase64Encoded
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListInterviewerAnnounceLfQueryVariables,
  APITypes.ListInterviewerAnnounceLfQuery
>;
